<template>
  <v-app id="app">
    <ad-block-plus-enabled />
    <v-navigation-drawer fixed :right="right" clipped app v-model="drawer" class="elevation-12">
      <navigation-bar-items />
    </v-navigation-drawer>
    <v-toolbar app :clippedLeft="!right" :clippedRight="right" fixed :color="baseColor">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="!right" />
      <v-toolbar-title>
        <h1 v-html="$store.getters.getLangKey('blogTitle')" class="headline" />
        <h2 class="title">
          <router-link v-html="$store.getters.getLangKey('blogTagline')" to="/" />
        </h2>
      </v-toolbar-title>
      <v-spacer />
      <router-link
        to="/"
        class="no-color"
        :title="$store.getters.getLangKey('home')">
        <v-icon class="ml-3 mr-3">home</v-icon>
      </router-link>
      <router-link
        v-if="sidebar.items.infoBox"
        :to="`${pageTopSlug}/${infoBoxData.slug}`"
        class="no-color mr-2"
        :title="$store.getters.getLangKey('aboutMe')">
        <v-icon>account_box</v-icon>
      </router-link>
      <a
        v-if="contactPage && contactPage.includes('http')"
        :href="contactPage"
        target="_blank"
        class="no-color inline-flex"
        :title="$store.getters.getLangKey('contactMe')">
      >
        <v-icon>email</v-icon>
      </a>
      <router-link
        class="no-color ml-2"
        :to="`${pageTopSlug}${contactPage}`"
        v-else-if="contactPage && !contactPage.includes('http')"
      >
        <v-icon>email</v-icon>
      </router-link>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="right" />
    </v-toolbar>
    <v-content>
      <v-container>
        <announcements-bar />
        <router-view />
      </v-container>
    </v-content>
    <v-footer app>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-right">
            &copy; 2006-{{ year }} <a :href="$store.state.domain" v-html="$store.getters.getLangKey('blogTagline')" />
          </div>
        </v-flex>
      </v-layout>
    </v-footer>
    <loading-overlay />
    <social-bar />
    <cookie-consent-bar
      ok="Dismiss"
      view="Policy"
      days="14"
      page="cookie-policy-for-this-blog"
      :cookie="$store.state.consentCookieName"
      :message="$store.getters.getLangKey('cookieConsentMessage')" />
  </v-app>
</template>
<script>
  import Mixins from './helpers/Mixins'
  import LoadingOverlay from './components/LoadingOverlay.vue'
  import AnnouncementsBar from './components/AnnouncementsBar'
  import SocialBar from './components/SocialBar.vue'
  import CookieConsentBar from './components/CookieConsentBar.vue'
  import NavigationBarItems from './components/NavigationBarItems.vue'
  import AdBlockPlusEnabled from './components/AdBlockPlusEnabled'

  export default {
    name: 'app',
    mixins: [
      Mixins
    ],
    components: {
      LoadingOverlay,
      AnnouncementsBar,
      SocialBar,
      CookieConsentBar,
      NavigationBarItems,
      AdBlockPlusEnabled
    },
    data () {
      return {
        drawer: null,
        year: new Date().getFullYear(),
        infoBoxData: this.$store.getters.getInfoBox,
        baseColor: this.$store.state.baseColor,
        sidebar: this.$store.getters.sidebar,
        pageTopSlug: this.$store.state.pageTopSlug,
        right: this.$store.getters.sidebar.position !== 'left',
        contactPage: this.$store.state.contactPage,
        initialized: false
      }
    },
    created () {
      const state = this.$store.state
      this.$root.$on(state.events.pageLoaded, () => {
        if (!this.initialized) {
          const element = document.querySelector('aside + .toolbar')
          const color = getComputedStyle(element, null).getPropertyValue('background-color')
          const sheet = (function () {
            const style = document.createElement('style')
            style.setAttribute('type', 'text/css')
            style.appendChild(document.createTextNode(''))
            document.head.appendChild(style)
            return style.sheet
          })()
          sheet.insertRule(
            `main .container a:not(.btn):not([target="_blank"]),
            .navigation-drawer > .list a.list__tile--active.list__tile.list__tile--link.primary--text,
            a.primary--text.list__tile--active.list__tile.list__tile--link:not(.btn),
            .footer a {
              color: ${color} !important;
              font-weight: 450;
              opacity: .7;
            }`, 0)
          sheet.insertRule(
            `main .container a:not(.btn):not([target="_blank"]):hover,
            .navigation-drawer > .list a.list__tile--active.list__tile.list__tile--link.primary--text:hover,
            a.primary--text.list__tile--active.list__tile.list__tile--link:not(.btn):hover,
            .footer a:hover {
              opacity: 1;
            }`, 0)
          this.initialized = true
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue